const userHasPermission = (user, ...perms) => (
  user?.isSuperuser || [...perms].some((perm) => user?.permissions?.includes(perm))
);

export default userHasPermission;
